/**
 * Created by yniran on 23/12/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        SurveyQuestionModel = require("connection-models/chatTab/SurveyQuestionModel"),
        SurveyQuestionsCollection = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        SurveyQuestionsCollection = Backbone.Collection.extend({
            model: SurveyQuestionModel,

            constructor: function (models, options) {

                var surveyInfo = options.surveyInfo;
                this._surveyLogic = new lpTag.taglets.SurveyLogic({survey: surveyInfo});

                models = this._getModelsFromQuestions(this._surveyLogic);

                Backbone.Collection.prototype.constructor.call(this, models, options);
            },

            getQuestionAnswers: function (model) {
                var question = this._getQuestionFromModel(model);
                var answers =[];

                if (question && question.entry) {
                    answers = _.pluck(question.entry, "value");
                }

                return answers;
            },

            submitAnswer: function (model, value) {
                this._surveyLogic.submitAnswer(model.get("id"), value);
            },

            validateSurvey: function(){

                var isValid = true;

                this.each(function(m){
                    isValid = m.isValid() ? isValid : false;
                });

                return isValid;
            },

            isValidAnswer: function (model) {

                var result = false;
                var qType = model.get("type");
                var types = lpTag.taglets.SurveyLogic.prototype.questionTypes;
                var question = this._getQuestionFromModel(model);

                switch (qType) {
                    case types.TEXT:
                    case types.TEXTF:
                        result = this._surveyLogic.validateTextQuestion(question);
                        break;
                    case types.SELECT:
                    case types.RADIO:
                    case types.RADIOH:
                    case types.CHECKBOX:
                        result = this._surveyLogic.validateMultiOptionQuestion(question);
                        break;
                }

                return result;
            },

            getSurveyJson: function(){

                return this._surveyLogic.getJSONSurvey();
            },

            _getQuestionFromModel: function (model) {
                return this._surveyLogic.getQuestionById(model.get("id"));
            },

            _getModelsFromQuestions: function (surveyLogic) {
                return surveyLogic.getActiveQuestions();     //not supporting survey logic. logic questions will not show!
            }
        });
    });

    return SurveyQuestionsCollection;
});